import { CfIconDynamicProps } from "../types";
import { icons } from "../icons";
import { logDebug } from "helpers/generic";
import React from "react";

const IconDynamic = ({ name }: CfIconDynamicProps) => {
  if (!icons[name]) {
    logDebug("missing icon->", name);
    process.exit(1);
  }

  const Icon = icons[name];

  return <Icon />;
};

export default IconDynamic;
